import React, { useCallback, useRef, useState, useEffect } from "react";
import {
  AppProvider,
  ActionList,
  Card,
  TextField,
  TextContainer,
  ContextualSaveBar,
  FormLayout,
  Modal,
  Frame,
  Layout,
  Loading,
  Navigation,
  Page,
  SkeletonBodyText,
  SkeletonDisplayText,
  SkeletonPage,
  Toast,
  TopBar,
  Text,
} from "@shopify/polaris";
import {
  ProfileMinor,
  LogOutMinor,
  CustomersMajor,
  PageMajor,
  ViewMajor,
  SettingsMajor,
  LanguageMinor,
  ProfileMajor,
  IconsMajor,
  AnalyticsMajor,
  NotificationMajor,
  LockMajor,
  BlogMajor,
  LinkMinor,
  DnsSettingsMajor,
  NavigationMajor,
  ChannelsMajor,
  CategoriesMajor,
  TemplateMajor,
  PaymentsMajor,
  AutomationMajor,
  CollectionsMajor,
  ArrowUpMinor,
  JobsFilledMajor,
  JobsMajor,
  FileFilledMinor,
  ListMajor,
  GiftCardFilledMinor,
  GiftCardMajor,
} from "@shopify/polaris-icons";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import {
  adminRole,
  accessDashboard,
  accessViewPages,
  accessUiText,
  accessNavigation,
  accessCrm,
  accessViewBlogs,
  accessSettings,
} from "../Helpers";
import axios from "../Assets/Lib/axios";
import bookmarkPin from "../Assets/Images/bookmark-pin.svg";

function NavigationLayout(props) {
  const navigate = useNavigate();
  const [logoImg, setLogoImg] = useState("");
  import(`../Assets/Images/${process.env.REACT_APP_CLIENT}-logoWhite.svg`).then(
    (module) => {
      setLogoImg(module.default);
    }
  );
  const defaultState = useRef({
    emailFieldValue: "dharma@jadedpixel.com",
    nameFieldValue: "Jaded Pixel",
  });
  const skipToContentRef = useRef(null);
  const [toastActive, setToastActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [userMenuActive, setUserMenuActive] = useState(false);
  const [mobileNavigationActive, setMobileNavigationActive] = useState(false);
  const [modalActive, setModalActive] = useState(false);
  const [nameFieldValue, setNameFieldValue] = useState(
    defaultState.current.nameFieldValue
  );
  const [emailFieldValue, setEmailFieldValue] = useState(
    defaultState.current.emailFieldValue
  );
  const [storeName, setStoreName] = useState(
    defaultState.current.nameFieldValue
  );
  const [supportSubject, setSupportSubject] = useState("");
  const [supportMessage, setSupportMessage] = useState("");

  const handleSubjectChange = useCallback(
    (value) => setSupportSubject(value),
    []
  );
  const handleMessageChange = useCallback(
    (value) => setSupportMessage(value),
    []
  );
  const handleDiscard = useCallback(() => {
    setEmailFieldValue(defaultState.current.emailFieldValue);
    setNameFieldValue(defaultState.current.nameFieldValue);
    setIsDirty(false);
  }, []);
  const handleSave = useCallback(() => {
    defaultState.current.nameFieldValue = nameFieldValue;
    defaultState.current.emailFieldValue = emailFieldValue;

    setIsDirty(false);
    setToastActive(true);
    setStoreName(defaultState.current.nameFieldValue);
  }, [emailFieldValue, nameFieldValue]);
  const handleNameFieldChange = useCallback((value) => {
    setNameFieldValue(value);
    value && setIsDirty(true);
  }, []);
  const handleEmailFieldChange = useCallback((value) => {
    setEmailFieldValue(value);
    value && setIsDirty(true);
  }, []);
  const handleSearchResultsDismiss = useCallback(() => {
    setSearchActive(false);
    setSearchValue("");
  }, []);
  const handleSearchFieldChange = useCallback((value) => {
    setSearchValue(value);
    setSearchActive(value.length > 0);
  }, []);
  const toggleToastActive = useCallback(
    () => setToastActive((toastActive) => !toastActive),
    []
  );
  const toggleUserMenuActive = useCallback(
    () => setUserMenuActive((userMenuActive) => !userMenuActive),
    []
  );
  const toggleMobileNavigationActive = useCallback(
    () =>
      setMobileNavigationActive(
        (mobileNavigationActive) => !mobileNavigationActive
      ),
    []
  );
  const toggleIsLoading = useCallback(
    () => setIsLoading((isLoading) => !isLoading),
    []
  );
  const toggleModalActive = useCallback(
    () => setModalActive((modalActive) => !modalActive),
    []
  );

  const toastMarkup = toastActive ? (
    <Toast onDismiss={toggleToastActive} content="Changes saved" />
  ) : null;

  const userMenuActions = [
    {
      items: [
        {
          content: "Your profile",
          icon: ProfileMinor,
          onAction: () => navigate("/profile"),
        },
      ],
    },
    {
      items: [
        {
          content: "Log out",
          icon: LogOutMinor,

          onAction: () => {
            axios
              .post(`/logout`)
              .then((result) => {
                Cookies.set("cms-accesstoken", null);
                navigate("/");
              })
              .catch((err) => console.log(err));
          },
        },
      ],
    },
  ];
  const customIcon = {
    viewBox: "0 0 20 20",
    body: '<g transform="scale(0.5)"><path d="M16 0 C6 0 2 4 2 14 L2 22 L6 24 L6 30 L26 30 L26 24 L30 22 L30 14 C30 4 26 0 16 0 M9 12 A4.5 4.5 0 0 1 9 21 A4.5 4.5 0 0 1 9 12 M23 12 A4.5 4.5 0 0 1 23 21 A4.5 4.5 0 0 1 23 12"></path></g>',
  };
  const contextualSaveBarMarkup = isDirty ? (
    <ContextualSaveBar
      message="Unsaved changes"
      saveAction={{
        onAction: handleSave,
      }}
      discardAction={{
        onAction: handleDiscard,
      }}
    />
  ) : null;

  const userMenuMarkup = (
    <TopBar.UserMenu
      actions={userMenuActions}
      name={Cookies.get("cms-name") && Cookies.get("cms-name")}
      initials={
        Cookies.get("cms-name") &&
        Cookies.get("cms-name").split(" ")[0].charAt(0) +
          " " +
          Cookies.get("cms-name").split(" ")[1].charAt(0)
      }
      open={userMenuActive}
      onToggle={toggleUserMenuActive}
    />
  );
  // const secondaryMenuMarkup = (
  //   <TopBar.Menu
  //     activatorContent={[<span>aaa</span>]}
  //     // activatorContent={
  //     //   <div className="rowDiv">
  //     //     <div>a</div>
  //     //     <div className="ml-5" style={{ marginRight: "2rem" }}>
  //     //       b
  //     //     </div>
  //     //     <div>c</div>
  //     //   </div>
  //     // }
  //     // activatorContent={
  //     //   <div className="rowDiv">
  //     //     <div>a</div>
  //     //     <div className="ml-5" style={{ marginRight: "2rem" }}>
  //     //       b
  //     //     </div>
  //     //     <div>c</div>
  //     //   </div>
  //     // }
  //     open={true}
  //     // onOpen={toggleIsSecondaryMenuOpen}
  //     // onClose={toggleIsSecondaryMenuOpen}
  //     // actions={[
  //     //   {
  //     //     items: [{ content: "Community forums" }],
  //     //   },
  //     // ]}
  //   />
  // );
  const [bookmarks, setBookmarks] = useState(null);
  useEffect(() => {
    axios
      .get(`/bookmarks`)
      .then((result) => {
        setBookmarks(result.data.data);
      })
      .catch((err) => console.log(err));
  }, []);

  const dashboardTab = {
    url: "/",
    onClick: () => {
      navigate("/admin/dashboard");
      const newState = ref.current.map((obj) => {
        if (obj.label === "Dashboard") {
          return { ...obj, selected: true };
        }
        return { ...obj, selected: false };
      });
      setMenuTabs(newState);
    },
    label: "Dashboard",
    icon: AnalyticsMajor,
    selected: window.location.href.indexOf("/admin/dashboard") > -1,
    disabled: !accessDashboard(),
    // exactMatch: true,
  };
  const pagesTab = {
    url: "/",
    onClick: () => {
      navigate("/admin/pages");
      const newState = ref.current.map((obj) => {
        if (obj.label === "Pages") {
          return { ...obj, selected: true };
        }
        return { ...obj, selected: false };
      });
      setMenuTabs(newState);
    },
    label: "Pages",
    icon: PageMajor,
    selected: window.location.href.indexOf("/admin/pages") > -1,
    disabled: !accessViewPages(),
  };
  const uiTab = {
    url: "/",
    onClick: () => {
      navigate("/admin/ui-text");
      const newState = ref.current.map((obj) => {
        if (obj.label === "UI Text") {
          return { ...obj, selected: true };
        }
        return { ...obj, selected: false };
      });
      setMenuTabs(newState);
    },
    label: "UI Text",
    icon: LanguageMinor,
    selected: false,
    exactMatch: window.location.href.indexOf("/admin/ui-tab") > -1,
    disabled: !accessUiText(),
  };
  const navigationTab = {
    url: "/",
    onClick: () => {
      navigate("/admin/navigation");
      const newState = ref.current.map((obj) => {
        if (obj.label === "Navigation") {
          return { ...obj, selected: true };
        }
        return { ...obj, selected: false };
      });
      setMenuTabs(newState);
    },
    label: "Navigation",
    icon: NavigationMajor,
    selected: false,
    exactMatch: window.location.href.indexOf("/admin/navigation") > -1,
    disabled: !accessNavigation(),
  };
  const crmTab = {
    disabled: !accessCrm(),
    label: "CRM",
    url: "/",
    onClick: () => {
      navigate("/admin/crm/contacts");
      console.log(ref.current);
      const newState = ref.current.map((obj) => {
        if (obj.label === "CRM") {
          return {
            ...obj,
            selected: true,
            subNavigationItems: obj.subNavigationItems.map((obj2) => {
              if (obj2.label === "Contacts") {
                return {
                  ...obj2,
                  selected: true,
                };
              }
              return { ...obj2, selected: false };
            }),
          };
        }
        return { ...obj, selected: false };
      });
      setMenuTabs(newState);
    },
    icon: CustomersMajor,
    selected: window.location.href.indexOf("/admin/crm") > -1,
    subNavigationItems: [
      {
        onClick: () => {
          navigate("/admin/crm/contacts");
          const newState = ref.current.map((obj) => {
            if (obj.label === "CRM") {
              return {
                ...obj,
                selected: true,
                subNavigationItems: obj.subNavigationItems.map((obj2) => {
                  if (obj2.label === "Contacts") {
                    return {
                      ...obj2,
                      selected: true,
                    };
                  }
                  return { ...obj2, selected: false };
                }),
              };
            }
            return { ...obj, selected: false };
          });
          setMenuTabs(newState);
        },

        selected: window.location.href.indexOf("/admin/crm/contacts") > -1,
        label: "Contacts",
        icon: CustomersMajor,
      },
      // {
      //   onClick: () => {
      //     navigate("/admin/crm/companies");
      //     const newState = ref.current.map((obj) => {
      //       if (obj.label === "CRM") {
      //         return {
      //           ...obj,
      //           selected: true,
      //           subNavigationItems: obj.subNavigationItems.map((obj2) => {
      //             if (obj2.label === "Companies") {
      //               return {
      //                 ...obj2,
      //                 selected: true,
      //               };
      //             }
      //             return { ...obj2, selected: false };
      //           }),
      //         };
      //       }
      //       return { ...obj, selected: false };
      //     });
      //     setMenuTabs(newState);
      //   },

      //   selected: window.location.href.indexOf("/admin/crm/companies") > -1,
      //   label: "Companies",
      //   icon: CategoriesMajor,
      // },
      {
        onClick: () => {
          navigate("/admin/crm/campaigns");
          const newState = ref.current.map((obj) => {
            if (obj.label === "CRM") {
              return {
                ...obj,
                selected: true,
                subNavigationItems: obj.subNavigationItems.map((obj2) => {
                  if (obj2.label === "Campaigns") {
                    return {
                      ...obj2,
                      selected: true,
                    };
                  }
                  return { ...obj2, selected: false };
                }),
              };
            }
            return { ...obj, selected: false };
          });
          setMenuTabs(newState);
        },

        selected: window.location.href.indexOf("/admin/crm/campaigns") > -1,
        label: "Campaigns",
        icon: CategoriesMajor,
      },
      // {
      //   onClick: () => {
      //     navigate("/admin/crm/contacts-board");
      //     console.log(ref.current);
      //     const newState = ref.current.map((obj) => {
      //       if (obj.label === "CRM") {
      //         return {
      //           ...obj,
      //           selected: true,
      //           subNavigationItems: obj.subNavigationItems.map((obj2) => {
      //             if (obj2.label === "Contacts Board") {
      //               return {
      //                 ...obj2,
      //                 selected: true,
      //               };
      //             }
      //             return { ...obj2, selected: false };
      //           }),
      //         };
      //       }
      //       return { ...obj, selected: false };
      //     });
      //     setMenuTabs(newState);
      //   },

      //   selected:
      //     window.location.href.indexOf("/admin/crm/contacts-board") > -1,
      //   label: "Contacts Board",
      //   icon: Columns3Major,
      // },
      {
        onClick: () => {
          navigate("/admin/crm/deals");
          console.log(ref.current);
          const newState = ref.current.map((obj) => {
            if (obj.label === "CRM") {
              return {
                ...obj,
                selected: true,
                subNavigationItems: obj.subNavigationItems.map((obj2) => {
                  if (obj2.label === "Deals") {
                    return {
                      ...obj2,
                      selected: true,
                    };
                  }
                  return { ...obj2, selected: false };
                }),
              };
            }
            return { ...obj, selected: false };
          });
          setMenuTabs(newState);
        },

        selected: window.location.href.indexOf("/admin/crm/deals") > -1,
        label: "Deals",
        icon: PaymentsMajor,
      },

      {
        onClick: () => {
          navigate("/admin/crm/automation");
          console.log(ref.current);
          const newState = ref.current.map((obj) => {
            if (obj.label === "CRM") {
              return {
                ...obj,
                selected: true,
                subNavigationItems: obj.subNavigationItems.map((obj2) => {
                  if (obj2.label === "Automation") {
                    return {
                      ...obj2,
                      selected: true,
                    };
                  }
                  return { ...obj2, selected: false };
                }),
              };
            }
            return { ...obj, selected: false };
          });
          setMenuTabs(newState);
        },

        selected: window.location.href.indexOf("/admin/crm/automation") > -1,
        label: "Automation",
        icon: AutomationMajor,
      },
    ],
  };
  const blogsTab = {
    disabled: accessViewBlogs() === false,
    url: "/",
    onClick: () => {
      navigate("/admin/blogs");
      const newState = ref.current.map((obj) => {
        if (obj.label === "Blogs") {
          return { ...obj, selected: true };
        }
        return { ...obj, selected: false };
      });
      setMenuTabs(newState);
    },
    label: "Blogs",
    icon: BlogMajor,
    selected: window.location.href.indexOf("/admin/blogs") > -1,
  };
  const ref = useRef([
    dashboardTab,
    pagesTab,
    blogsTab,
    uiTab,
    navigationTab,
    crmTab,
  ]);
  const [menuTabs, setMenuTabs] = useState([
    dashboardTab,
    pagesTab,
    blogsTab,
    uiTab,
    navigationTab,
    crmTab,
  ]);

  useEffect(() => {
    let array = [];
    axios
      .get(`/settings/display-content`)
      .then((result) => {
        // const element = document.getElementsByClassName("Polaris-Navigation");
        // console.log("element=", element);
        // if (element) element.style.visibility = "hidden";
        console.log(result.data.data.length);
        if (result?.data.data?.length) {
          parseInt(result?.data?.data[1].main_menu?.dashboard) &&
            array.push(dashboardTab);
          parseInt(result?.data?.data[1].main_menu?.pages) &&
            array.push(pagesTab);
          parseInt(result?.data?.data[1].main_menu?.blogs) &&
            array.push(blogsTab);
          parseInt(result?.data?.data[1].main_menu?.ui_text) &&
            array.push(uiTab);
          parseInt(result?.data?.data[1].main_menu?.navigation) &&
            array.push(navigationTab);
          parseInt(result?.data?.data[1].main_menu?.crm) && array.push(crmTab);
          ref.current = array;
          setMenuTabs(array);
        } else {
          console.log("");
        }

        // console.log("array=", array);
        // setMenuTabs((current) =>
        //   current.filter((employee) => {
        //     // 👇️ remove object that has id equal to 2
        //     return employee.id !== 1;
        //   })
        // );
        // setSectionsVisibility(result.data);
      })
      .catch((err) => console.log(err));
  }, []);
  const secondaryMenuMarkup = (
    // <TopBar.Menu
    //   activatorContent={
    <div className="rowDiv">
      {bookmarks &&
        bookmarks.map((element, index) => {
          return (
            <div className="mytooltip rowDiv" key={index}>
              <div
                key={index}
                className="bookmarkDiv me-3 tooltiptext "
                style={{
                  backgroundColor: element.color ? element.color : "#efefef",
                }}
                // className="me-3"
                onClick={() => {
                  window.open(element.url, "_blank");
                }}
              >
                <img
                  src={bookmarkPin}
                  width={23}
                  className="centered-element"
                />
                <p style={{ marginLeft: "2rem" }}>{element.name}</p>
              </div>
              <span className="mytext">{element.url}</span>
            </div>

            // <div className="tooltipDiv rowDiv" key={index}>
            //   <span
            //     key={index}
            //     className="bookmarkDiv me-3 tooltiptext"
            //     style={{ cursor: "pointer", color: "black" }}
            //     // className="me-3"
            //     onClick={() => {
            //       window.open(element.url, "_blank");
            //     }}
            //   >
            //     {element.name}
            //   </span>
            //   <span className="tooltiptext">Tooltip text</span>
            // </div>

            // <span
            //   key={index}
            //   className="bookmarkDiv me-3"
            //   style={{ cursor: "pointer", color: "black" }}
            //   // className="me-3"
            //   onClick={() => {
            //     window.open(element.url, "_blank");
            //   }}
            // >
            //   {element.name}
            // </span>
          );
        })}
    </div>
  );
  const searchResultsMarkup = (
    <ActionList
      items={[
        { content: "Shopify help center" },
        { content: "Community forums" },
      ]}
    />
  );

  const searchFieldMarkup = (
    <TopBar.SearchField
      onChange={handleSearchFieldChange}
      value={searchValue}
      placeholder="Search"
    />
  );

  const topBarMarkup = (
    <TopBar
      showNavigationToggle
      userMenu={userMenuMarkup}
      secondaryMenu={secondaryMenuMarkup}
      searchResults={searchResultsMarkup}
      searchResultsVisible={true}
      // searchField={searchFieldMarkup}
      // searchResults={searchResultsMarkup}
      // onSearchResultsDismiss={handleSearchResultsDismiss}
      onNavigationToggle={toggleMobileNavigationActive}
      logoSuffix
    />
  );

  const navigationMarkup = (
    <Navigation location="/">
      <Navigation.Section
        items={
          process.env.REACT_APP_CLIENT === "hanzo"
            ? menuTabs.concat({
                url: "/",
                onClick: () => {
                  navigate("/admin/projects");
                  const newState = ref.current.map((obj) => {
                    return { ...obj, selected: false };
                  });
                  setMenuTabs(newState);
                },
                label: "Projects",
                icon: CategoriesMajor,
                selected: window.location.href.indexOf("/admin/projects") > -1,
              })
            : process.env.REACT_APP_CLIENT === "face"
            ? menuTabs.concat({
                url: "/",
                onClick: () => {
                  navigate("/admin/portfolio");
                  const newState = ref.current.map((obj) => {
                    return { ...obj, selected: false };
                  });
                  setMenuTabs(newState);
                },
                label: "Portfolio",
                icon: CategoriesMajor,
                selected: window.location.href.indexOf("/admin/portfolio") > -1,
              })
            : process.env.REACT_APP_CLIENT === "chapha"
            ? menuTabs.concat({
                url: "/",
                onClick: () => {
                  navigate("/admin/products");
                  const newState = ref.current.map((obj) => {
                    return { ...obj, selected: false };
                  });
                  setMenuTabs(newState);
                },
                label: "Products",
                icon: CategoriesMajor,
                selected: window.location.href.indexOf("/admin/products") > -1,
              })
            : process.env.REACT_APP_CLIENT === "innovest"
            ? menuTabs.concat({
                url: "/",
                onClick: () => {
                  navigate("/admin/projects-innovest");
                  const newState = ref.current.map((obj) => {
                    return { ...obj, selected: false };
                  });
                  setMenuTabs(newState);
                },
                label: "Projects",
                icon: CategoriesMajor,
                selected:
                  window.location.href.indexOf("/admin/projects-innovest") > -1,
              })
            : process.env.REACT_APP_CLIENT === "mindset"
            ? menuTabs.concat([
                {
                  url: "/",
                  onClick: () => {
                    navigate("/admin/talent");
                    const newState = ref.current.map((obj) => {
                      return { ...obj, selected: false };
                    });
                    setMenuTabs(newState);
                  },
                  label: "Talent",
                  icon: CategoriesMajor,
                  selected: window.location.href.indexOf("/admin/talent") > -1,
                },
                {
                  url: "/",
                  onClick: () => {
                    navigate("/admin/projects-mindset");
                    const newState = ref.current.map((obj) => {
                      return { ...obj, selected: false };
                    });
                    setMenuTabs(newState);
                  },
                  label: "MDev Projects",
                  icon: CategoriesMajor,
                  selected:
                    window.location.href.indexOf("/admin/projects-mindset") >
                    -1,
                },
              ])
            : process.env.REACT_APP_CLIENT === "4t"
            ? menuTabs.concat({
                url: "/",
                onClick: () => {
                  navigate("/admin/careers");
                  const newState = ref.current.map((obj) => {
                    return { ...obj, selected: false };
                  });
                  setMenuTabs(newState);
                },
                label: "Careers",
                icon: JobsMajor,
                selected: window.location.href.indexOf("/admin/careers") > -1,
              })
            : process.env.REACT_APP_CLIENT === "rugaib"
            ? menuTabs.concat({
                url: "/",
                onClick: () => {
                  navigate("/admin/otp-activities");
                  const newState = ref.current.map((obj) => {
                    return { ...obj, selected: false };
                  });
                  setMenuTabs(newState);
                },
                label: "OTP Activities",
                icon: FileFilledMinor,
                selected:
                  window.location.href.indexOf("/admin/otp-activities") > -1,
              })
            : process.env.REACT_APP_CLIENT === "webedia"
            ? menuTabs.concat([
                {
                  url: "/",
                  onClick: () => {
                    navigate("/admin/awards");
                    const newState = ref.current.map((obj) => {
                      return { ...obj, selected: false };
                    });
                    setMenuTabs(newState);
                  },
                  label: "Awards",
                  icon: ListMajor,
                  selected: window.location.href.indexOf("/admin/awards") > -1,
                },
                {
                  url: "/",
                  onClick: () => {
                    navigate("/admin/case-studies");
                    const newState = ref.current.map((obj) => {
                      return { ...obj, selected: false };
                    });
                    setMenuTabs(newState);
                  },
                  label: "Case Studies",
                  icon: CategoriesMajor,
                  selected:
                    window.location.href.indexOf("/admin/case-studies") > -1,
                },
              ])
            : menuTabs
        }
      ></Navigation.Section>
      <Navigation.Section
        separator
        items={[
          {
            label: "Settings",
            disabled: !accessSettings(),
            url: "/",
            onClick: () => {
              navigate("/admin/settings/languages");
              const newState = ref.current.map((obj) => {
                return { ...obj, selected: false };
              });
              setMenuTabs(newState);
            },
            icon: SettingsMajor,
            selected: window.location.href.indexOf("/admin/settings") > -1,
            subNavigationItems: [
              // {
              //   onClick: () => navigate("/admin/settings/pages-tags"),
              //   selected:
              //     window.location.href.indexOf("/admin/settings/pages-tags") >
              //       -1 && true,
              //   label: "Pages Tags",
              //   icon: CollectionsMajor,
              // },
              {
                onClick: () => navigate("/admin/settings/languages"),
                selected:
                  window.location.href.indexOf("/admin/settings/languages") >
                    -1 && true,
                label: "Languages",
                icon: LanguageMinor,
              },
              {
                onClick: () => navigate("/admin/settings/channels"),
                selected:
                  window.location.href.indexOf("/admin/settings/channels") >
                    -1 && true,
                label: "Channels",
                icon: ChannelsMajor,
              },

              {
                onClick: () =>
                  navigate("/admin/settings/social-media-and-links"),
                selected:
                  window.location.href.indexOf("/admin/settings/social-media") >
                  -1,
                label: "Social Media and Links",
                icon: LinkMinor,
              },
              {
                disabled: adminRole() === "Editor" && true,
                onClick: () => navigate("/admin/settings/brand"),
                selected:
                  window.location.href.indexOf("/admin/settings/brand") > -1 &&
                  true,
                label: "Brand",
                icon: IconsMajor,
              },
              {
                onClick: () => navigate("/admin/settings/contact-information"),
                selected:
                  window.location.href.indexOf(
                    "/admin/settings/contact-information"
                  ) > -1 && true,
                label: "Notifications",
                icon: NotificationMajor,
                disabled: adminRole() === "Editor" && true,
              },
              {
                onClick: () =>
                  navigate("/admin/settings/users-and-permissions"),
                selected:
                  window.location.href.indexOf(
                    "/admin/settings/users-and-permissions"
                  ) > -1 && true,
                label: "Users and Permissions",
                icon: ProfileMajor,
                disabled: adminRole() !== "Super" && true,
              },
              {
                onClick: () => navigate("/admin/settings/bookmarks"),
                selected:
                  window.location.href.indexOf("/admin/settings/bookmarks") >
                    -1 && true,
                label: "Bookmarks",
                icon: LinkMinor,
              },
              //   onClick: () =>
              //     navigate("/admin/settings/google-analytics-account"),
              //   selected:
              //     window.location.href.indexOf(
              //       "/admin/settings/google-analytics-account"
              //     ) > -1 && true,
              //   label: "Google Analytics Account",
              //   icon: AnalyticsMajor,
              // },
              {
                onClick: () => navigate("/admin/settings/access-password"),
                selected:
                  window.location.href.indexOf(
                    "/admin/settings/access-password"
                  ) > -1 && true,
                label: "Access Password",
                icon: LockMajor,
                disabled: adminRole() === "Editor" && true,
              },
              {
                onClick: () => navigate("/admin/settings/integrations"),
                selected:
                  window.location.href.indexOf("/admin/settings/integrations") >
                    -1 && true,
                label: "Integrations",
                icon: DnsSettingsMajor,
              },
              {
                onClick: () =>
                  navigate("/admin/settings/sections-customization"),
                selected:
                  window.location.href.indexOf(
                    "/admin/settings/sections-customization"
                  ) > -1 && true,
                label: "Display/Hide Sections",
                icon: ViewMajor,
              },
              {
                onClick: () => navigate("/admin/settings/templates"),
                selected:
                  window.location.href.indexOf("/admin/settings/templates") >
                    -1 && true,
                label: "Templates",
                icon: TemplateMajor,
              },
              {
                onClick: () => navigate("/admin/settings/app-settings"),
                selected:
                  window.location.href.indexOf("/admin/settings/app-settings") >
                    -1 && true,
                label: "App Settings",
                icon: SettingsMajor,
              },

              (process.env.REACT_APP_CLIENT === "innovest" ||
                process.env.REACT_APP_CLIENT === "face" ||
                process.env.REACT_APP_CLIENT === "chapha") && {
                onClick: () => navigate("/admin/settings/deploy"),
                selected:
                  window.location.href.indexOf("/admin/settings/deploy") > -1 &&
                  true,
                label: "Publish",
                icon: ArrowUpMinor,
              },
              (process.env.REACT_APP_CLIENT === "creoshift" ||
                process.env.REACT_APP_CLIENT === "feel22" ||
                process.env.REACT_APP_CLIENT === "feel22iraq" ||
                process.env.REACT_APP_CLIENT === "feel22egypt") && {
                onClick: () => navigate("/admin/settings/gift-rules"),
                selected:
                  window.location.href.indexOf("/admin/settings/gift-rules") >
                    -1 && true,
                label: "Gift Rules",
                icon: GiftCardMajor,
              },
              // (process.env.REACT_APP_CLIENT === "creoshift" ||
              //   process.env.REACT_APP_CLIENT === "feel22" ||
              //   process.env.REACT_APP_CLIENT === "feel22iraq" ||
              //   process.env.REACT_APP_CLIENT === "feel2egypt") && {
              //   onClick: () => navigate("/admin/settings/gift-rules"),
              //   selected:
              //     window.location.href.indexOf("/admin/settings/gift-rules") >
              //       -1 && true,
              //   label: "Gift Rules",
              //   icon: CategoriesMajor,
              // },
              // {
              //   onClick: () => navigate("/admin/settings/shopify-domain"),
              //   selected:
              //     window.location.href.indexOf(
              //       "/admin/settings/shopify-domain"
              //     ) > -1 && true,
              //   label: "Shopify Domain",
              //   icon: LinkMinor,
              // },
              //
            ],
          },
        ]}
      />
    </Navigation>
  );
  const loadingMarkup = isLoading ? <Loading /> : null;

  const skipToContentTarget = (
    <a id="SkipToContentTarget" ref={skipToContentRef} tabIndex={-1} />
  );

  const actualPageMarkup = (
    <Page title="Account">
      <Layout>
        {skipToContentTarget}
        <Layout.AnnotatedSection
          title="Account details"
          description="Jaded Pixel will use this as your account information."
        >
          <Card sectioned>
            <FormLayout>
              <TextField
                label="Full name"
                value={nameFieldValue}
                onChange={handleNameFieldChange}
              />
              <TextField
                type="email"
                label="Email"
                value={emailFieldValue}
                onChange={handleEmailFieldChange}
              />
            </FormLayout>
          </Card>
        </Layout.AnnotatedSection>
      </Layout>
    </Page>
  );

  const loadingPageMarkup = (
    <SkeletonPage>
      <Layout>
        <Layout.Section>
          <Card sectioned>
            <TextContainer>
              <SkeletonDisplayText size="small" />
              <SkeletonBodyText lines={9} />
            </TextContainer>
          </Card>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );

  const pageMarkup = isLoading ? loadingPageMarkup : actualPageMarkup;

  const modalMarkup = (
    <Modal
      open={modalActive}
      onClose={toggleModalActive}
      title="Contact support"
      primaryAction={{
        content: "Send",
        onAction: toggleModalActive,
      }}
    >
      <Modal.Section>
        <FormLayout>
          <TextField
            label="Subject"
            value={supportSubject}
            onChange={handleSubjectChange}
          />
          <TextField
            label="Message"
            value={supportMessage}
            onChange={handleMessageChange}
            multiline
          />
        </FormLayout>
      </Modal.Section>
    </Modal>
  );

  const theme = {
    colors: {
      surface: "#FFFFFF",
      onsurface: "#212B36",
    },
  };
  const logo = {
    width: 150,
    topBarSource: logoImg,
    // url: "/admin/dashboard",
    // accessibilityLabel: "Jaded Pixel",
  };

  return (
    <div style={{ height: "500px" }}>
      <AppProvider
        // theme={theme}
        i18n={{
          Polaris: {
            Avatar: {
              label: "Avatar",
              labelWithInitials: "Avatar with initials {initials}",
            },
            ContextualSaveBar: {
              save: "Save",
              discard: "Discard",
            },
            TextField: {
              characterCount: "{count} characters",
            },
            TopBar: {
              toggleMenuLabel: "Toggle menu",

              SearchField: {
                clearButtonLabel: "Clear",
                search: "Search",
              },
            },
            Modal: {
              iFrameTitle: "body markup",
            },
            Frame: {
              skipToContent: "Skip to content",
              Navigation: {
                closeMobileNavigationLabel: "Close navigation",
              },
            },
          },
        }}
      >
        <Frame
          topBar={topBarMarkup}
          navigation={navigationMarkup}
          showMobileNavigation={mobileNavigationActive}
          onNavigationDismiss={toggleMobileNavigationActive}
          skipToContentTarget={skipToContentRef.current}
          logo={logo}
        >
          {props.children}
        </Frame>
      </AppProvider>
    </div>
  );
}
export default React.memo(NavigationLayout);
